import React from "react";
import { SVGProps } from "react";

export default function BurgerMenu(props: SVGProps<SVGSVGElement>) {
  // This component renders a simple hamburger menu icon
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 12H21M3 6H21M3 18H21"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
